module.exports = {
    title: "Work Type",
    crud: {
        create: "Create Work Type",
        edit: "Edit Work Type",
        view: "View Work Type",
    },
    table: {
        title: "Title",
        isActive: 'Active',
    },
    form: {
        title: "Title",
        isActive: 'Active',
    },
    validation: {
        required: {
            title: 'Title is required',
        },
        minLength: {
            title: 'title must have at least',
        },
        common: {
            letter: 'letters.',
        }
    },
}
